import { Title } from '@bpm-web-app/components';
import { FreeSounds } from '@bpm-web-app/components/pages';

export default function freeSoundsPage({ title }: { title: string }) {
    return (
        <>
            <Title platform="create" title={title} />
            <FreeSounds />
        </>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'Free Packs & Sounds'
        }
    };
}
